export enum FeatureFlag {
  DARK_MODE_TOGGLE_ENABLED = 'DARK_MODE_TOGGLE_ENABLED',
  HOME_PAGE_V2_SHOW_CLIENTS = 'HOME_PAGE_V2_SHOW_CLIENTS'
};